import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["use", "children"];
import { Flex } from '../../../components/Flex';
import { createContext, useContext } from 'react';
import { getVariantStyles } from './ToolBar.helpers';
import styled from 'styled-components';
import { StyledLink } from '../Link/Link';
import { getColorTokensForUse as getLinkColorTokensForUse } from '../Link/Link.styles';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledToolBar = styled.div.withConfig({
  displayName: "ToolBar__StyledToolBar",
  componentId: "sc-1szulo9-0"
})(({
  theme: _theme,
  $use
}) => {
  const theme = _theme;
  return Object.assign({}, $use !== 'filter-bar' && {
    [`& ${StyledLink}`]: {
      fontWeight: theme.typography['heading-50'].fontWeight,
      fontSize: theme.typography['heading-50'].fontSize,
      color: theme.color[getLinkColorTokensForUse('on-dark').idle],
      '&:hover': {
        color: theme.color[getLinkColorTokensForUse('on-dark').hover],
        textDecoration: 'underline solid'
      }
    }
  });
});
export const ToolBarContext = /*#__PURE__*/createContext({
  toolBar: false
});
export const useToolBarContext = () => {
  const toolBarContext = useContext(ToolBarContext);
  return toolBarContext;
};
export const ToolBar = _ref => {
  let {
      use = 'default',
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const variantStyles = getVariantStyles(use);
  return /*#__PURE__*/_jsx(ToolBarContext.Provider, {
    value: {
      toolBar: use !== 'filter-bar'
    },
    children: /*#__PURE__*/_jsx(StyledToolBar, {
      $use: use,
      children: /*#__PURE__*/_jsx(Flex, Object.assign({
        role: "group",
        alignItems: "center",
        flexDirection: "row",
        flexWrap: "wrap",
        inlineSize: "100%",
        justifyContent: "space-between",
        paddingInline: "500"
      }, variantStyles, rest, {
        children: children
      }))
    })
  });
};